export const COLORS = ['red', 'blue', 'green', 'yellow'];
//# sourceMappingURL=types.js.map